import { useEffect, useState } from "react";
import { IdentificationCard } from "@phosphor-icons/react";
import Layout from "../components/Layout";
import EmptyState from "../components/EmptyState";
import api from "../lib/api";

export default function Staff() {
  const [staff, setStaff] = useState(null);

  useEffect(() => {
    api.get("/staff").then((r) => setStaff(r.data)).catch(() => setStaff([]));
  }, []);

  if (staff === null) {
    return <Layout title="Staff"><div className="h-64 animate-pulse rounded-lg border border-slate-200 bg-white" /></Layout>;
  }

  if (staff.length === 0) {
    return (
      <Layout title="Staff">
        <EmptyState icon={IdentificationCard} title="No staff yet" message="Create staff accounts from the Users page and assign a salesman identity + floor." testId="staff-empty" />
      </Layout>
    );
  }

  return (
    <Layout title="Staff">
      <div className="animate-fade-in space-y-4">
        <p className="text-sm text-slate-500">
          Staff master · {staff.length} members. Current floor is used for live dashboards only — historical attribution always comes from the uploaded Excel.
        </p>
        <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {staff.map((s) => (
            <div key={s.id} className="rounded-lg border border-slate-200 bg-white p-5" data-testid={`staff-card-${s.username}`}>
              <div className="flex items-center justify-between">
                <div className="flex h-10 w-10 items-center justify-center rounded-full bg-blue-100 font-bold text-blue-700">
                  {s.name?.[0]?.toUpperCase()}
                </div>
                <span className={`rounded-full px-2 py-0.5 text-xs font-semibold ${s.active ? "bg-emerald-100 text-emerald-700" : "bg-slate-200 text-slate-500"}`}>
                  {s.active ? "Active" : "Inactive"}
                </span>
              </div>
              <div className="mt-3 font-display text-lg font-bold text-slate-900">{s.name}</div>
              <div className="mt-1 space-y-0.5 text-sm text-slate-500">
                <div>Username: <span className="font-mono-data">@{s.username}</span></div>
                <div>Salesman: <b className="text-slate-700">{s.salesman_name || "—"}</b></div>
                <div>Floor: <b className="text-slate-700">{s.current_floor || "—"}</b></div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
